import React from 'react'
import RowPrint from './RowPrint'

const PaperPrint = ({ papers, fullNameInContainer, fullNameBelowPaper }) => {
  return (
    <div className="d-none paper-print">
      <div className="sub-paper-print">
        {papers.map((rows, index) => {
          return (
            <RowPrint key={index} rows={rows} fullNameInContainer={fullNameInContainer} />
          )
        })}
        <div className="full-name-below-paper">{fullNameBelowPaper}</div>
      </div>
    </div>
  )
}

export default PaperPrint
